import { configureStore } from "@reduxjs/toolkit";
import colorThemeReducer from "./colorThemeSlice.js";

export const store = configureStore({
	reducer: {
		themeColorPalete: colorThemeReducer,
	},
});